import { getDatabricksAccessToken } from './msal'

// ---------------------------------------------------------------------------
// Authentication helper for Databricks / Prism Intelligence API calls.
//
// All sign-in is via Microsoft SSO (see src/pages/signin/SignIn.tsx), so
// every API call is authenticated with the MSAL-acquired user access token
// for the Databricks Azure resource.
// ---------------------------------------------------------------------------

/**
 * Return the active bearer token for Databricks / Prism Intelligence API
 * calls, acquired via MSAL for the currently signed-in Microsoft account.
 */
export async function getAccessToken(): Promise<string> {
  const token = await getDatabricksAccessToken()
  if (token) {
    return token
  }
  throw new Error(
    'Could not acquire a Databricks access token for your Microsoft account. Please sign in again.'
  )
}
